/* globals jQuery, Modernizr, google */
jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	const $page = $( 'html, body' );
	const $html = $( 'html' );
	const $body = $( 'body' );

	// =========================
	// ! Utilities
	// =========================

	const { get, fn } = $;

	// Dirt cheap classList polyfill
	function ClassList( el ) {
		const classes = el.className.split( /\s+/ );

		for ( let i = 0; i < classes.length; i++ ) {
			this[ i ] = classes[ i ];
		}

		this.length = classes.length;

		this.remove = className => {
			el.className = el.className.replace( new RegExp( '(^|\\b)' + className.split( ' ' ).join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
		};

		this.add = className => {
			el.className += ' ' + className;
		};
	}

	// Set/Remove/Replace a class with a prefix
	fn.setFlagClass = function( flag, value ) {
		return $( this ).each( function() {
			const classes = this.classList || new ClassList( this );

			// Remove the old class
			for ( let i = 0; i < classes.length; i++ ) {
				const className = classes[ i ];
				if ( className.indexOf( `${ flag }-` ) === 0 ) {
					classes.remove( className );
				}
			}

			// Add the new one if value is set
			if ( value ) {
				classes.add( `${ flag }-${ value }` );
			}
		} );
	};

	// =========================
	// ! Supports Flagging
	// =========================

	let IS_TOUCH = false;

	$body.removeClass( 'no-js' ).addClass( 'js' );

	$document
		.on( 'touchstart', function() {
			IS_TOUCH = true;
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Fallbacks/Polyfills
	// =========================

	const isIE = ( () => {
		const ua = window.navigator.userAgent;

		return ua.indexOf( 'MSIE ' ) >= 0 || ua.indexOf( 'Trident/' ) >= 0;
	} )();

	$html.toggleClass( 'is-ie', isIE );

	function testCSSProperty( elm, property, input, output ) {
		property = Modernizr.prefixed( property );

		elm.style[ property ] = input;

		return elm.style[ property ] === output;
	}

	const htmlClipPathSupport = ( () => {
		if ( isIE ) {
			return false;
		}

		const elm = document.createElement( 'div' );
		const pathInput = 'polygon( 0% 0%, 0% 0%, 0% 0% )';
		const pathOutput = 'polygon(0% 0%, 0% 0%, 0% 0%)';
		const urlInput = 'url( #hexagon-vertical )';
		const urlOutput = 'url("#hexagon-vertical")';

		return testCSSProperty( elm, 'clip-path', pathInput, pathOutput ) ||
			testCSSProperty( elm, 'clip-path', urlInput, urlOutput );
	} )();

	$html.addClass( `supports-${ htmlClipPathSupport ? '' : 'no-' }clippath` );

	if ( ! htmlClipPathSupport && Modernizr && Modernizr.inlinesvg && Modernizr.svgclippaths ) {
		// Convert hexcrop images to SVGs
		// Applying on all browsers for consistency
		$( 'img.hexcrop, .hexcrop > img' ).each( function() {
			const width = this.getAttribute( 'width' ) || this.width;
			const height = this.getAttribute( 'height' ) || this.height;

			const size = Math.max( width, height );

			const svg = document.createElementNS( 'http://www.w3.org/2000/svg', 'svg' );
			svg.setAttribute( 'viewBox', `0 0 ${ size } ${ size }` );
			svg.setAttribute( 'class', this.className );

			const image = document.createElementNS( 'http://www.w3.org/2000/svg', 'image' );
			image.setAttributeNS( 'http://www.w3.org/1999/xlink', 'xlink:href', this.src );
			image.setAttribute( 'width', size );
			image.setAttribute( 'height', size );

			svg.appendChild( image );

			$( this ).after( svg ).remove();
		} );
	}

	// =========================
	// ! Scroll Locking
	// =========================

	let scrollLock = false;
	let preScrollLock = $window.scrollTop();

	$window.scroll( function() {
		if ( scrollLock ) {
			return;
		}

		preScrollLock = $window.scrollTop();
	} );

	// https://davidwells.io/snippets/disable-scrolling-with-javascript
	function noScroll() {
		window.scrollTo( 0, preScrollLock );
	}

	function lockScroll() {
		scrollLock = true;
		window.addEventListener( 'scroll', noScroll );
		$html.addClass( 'has-scrolling-locked' );
	}

	function unlockScroll() {
		scrollLock = false;
		window.removeEventListener( 'scroll', noScroll );
		$html.removeClass( 'has-scrolling-locked' );
	}

	// =========================
	// ! Common Interactions
	// =========================

	$( 'input.reset' ).each( function() {
		const $self = $( this );
		const $others = $( `input[name="${ this.name }"]` ).not( this );

		$( this ).change( function() {
			if ( this.checked ) {
				$others.attr( 'checked', false );
			}
		} );

		$others.change( function() {
			if ( this.checked ) {
				$self.attr( 'checked', false );
			}
		} );
	} );

	// Jump To
	const scrollMargin = 50;
	$( 'a[href^="#"]' ).click( function( e ) {
		e.preventDefault();

		if ( $( this ).hasClass( 'toggle' ) || $( this ).attr( 'rel' ) === 'tab' ) {
			return;
		}

		const $target = $( $( this ).attr( 'href' ) );

		let position = 0;
		if ( $target.length > 0 ) {
			position = $target.offset().top - scrollMargin;
		}

		$page.animate( { scrollTop: position } );
	} );

	// Accordion Table
	$( '.accordion-table' ).each( function() {
		const $toggles = $( this ).find( '.rowgroup-toggle' );

		$toggles.click( function() {
			$( this ).toggleClass( 'collapsed' );
			if ( ! $( this ).hasClass( 'collapsed' ) ) {
				$toggles.not( this ).addClass( 'collapsed' );
			}
		} );

		$toggles.not( ':first' ).addClass( 'collapsed' );
	} );

	// Accordion Block
	$( '.canpath-accordion__header' ).each( function() {
		const $parent = $( this ).parents( '.canpath-accordion-group' ).first();
		const $header = $( this );
		const $target = $header.next();

		$header.click( function() {
			$header.toggleClass( 'is-active' );
			if ( $header.hasClass( 'is-active' ) ) {
				$target.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ) );
				$parent.find( '.canpath-accordion__header' ).not( $header ).each( function() {
					if ( $( this ).hasClass( 'is-active' ) ) {
						$( this ).removeClass( 'is-active' );
						$( this ).next().stop().show().animate( { height: 'toggle' }, () => $( this ).next().attr( 'style', '' ).removeClass( 'open' ) );
					}
				} );
			} else {
				$target.stop().show().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ).removeClass( 'open' ) );
			}
		} );
	} );

	// Filter Toggles
	$( '.index-filter-set__nav-item' ).each( function() {
		const $parent = $( this ).parents( '.index-filter-set' ).first();
		const $toggle = $( this );
		const $target = $( $( this ).attr( 'href' ) );

		$toggle.click( function( e ) {
			e.preventDefault();

			$toggle.toggleClass( 'is-active' );
			if ( $toggle.hasClass( 'is-active' ) ) {
				$target.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ) );
				$parent.find( '.index-filter-set__nav-item' ).not( $toggle ).each( function() {
					if ( $( this ).hasClass( 'is-active' ) ) {
						$( this ).removeClass( 'is-active' );
						$( $( this ).attr( 'href' ) ).stop().show().animate( { height: 'toggle' }, () => $( this ).next().attr( 'style', '' ).removeClass( 'open' ) );
					}
				} );
			} else {
				$target.stop().show().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ).removeClass( 'open' ) );
			}
		} );
	} );

	// Toggle Buttons
	$( '.toggle' ).click( function( e ) {
		if ( this.tagName === 'a' ) {
			e.preventDefault();
		}

		const target = $( this ).data( 'toggle' ) || $( this ).attr( 'href' ).replace( '#', '' );

		const className = `show-${ target }`;

		if ( $body.hasClass( className ) ) {
			$body.removeClass( className );
		} else {
			$body.setFlagClass( 'show', target );
		}

		$( '.toggle' ).removeClass( 'is-active' );
		$( `.toggle[href="#${ target }"], .toggle[data-toggle="${ target }"]` ).toggleClass( 'is-active', $body.hasClass( className ) );

		$document.trigger( `toggle:${ target }` );
	} );

	// =========================
	// ! Google Map Handling
	// =========================

	if ( typeof google !== 'undefined' ) {
		class CSSMarker extends google.maps.OverlayView {
			constructor( options ) {
				super( options );

				this.position = options.position;

				this.elm = document.createElement( 'div' );
				this.elm.className = 'cssmarker';
			}

			onAdd() {
				this.elm.style = 'absolute';

				this.getPanes().overlayMouseTarget.appendChild( this.elm );
			}

			draw() {
				const { x, y } = this.getProjection().fromLatLngToDivPixel( this.position );

				this.elm.style.top = y + 'px';
				this.elm.style.left = x + 'px';
			}
		}

		$( '.canpath-google-map[data-config]' ).each( function() {
			const config = $( this ).data( 'config' );
			const { coords, ...options } = config;

			const map = new google.maps.Map( this, {
				center: coords,
				...options,
			} );

			const marker = new CSSMarker( {
				position: map.getCenter(),
			} );

			marker.setMap( map );
		} );
	}

	// =========================
	// ! Twitter Feed Handling
	// =========================

	const MINUTE_IN_SECONDS = 60;
	const HOUR_IN_SECONDS = MINUTE_IN_SECONDS * 60;
	const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24;
	const WEEK_IN_SECONDS = DAY_IN_SECONDS * 7;
	const YEAR_IN_SECONDS = DAY_IN_SECONDS * 365;

	function ago( time ) {
		const now = Date.now();

		const seconds = Math.floor( ( now - time ) / 1000 );

		let diff = seconds + 's';
		if ( seconds >= YEAR_IN_SECONDS ) {
			diff = Math.floor( seconds / YEAR_IN_SECONDS ) + 'y';
		} else if ( seconds >= WEEK_IN_SECONDS ) {
			diff = Math.floor( seconds / WEEK_IN_SECONDS ) + 'w';
		} else if ( seconds >= DAY_IN_SECONDS ) {
			diff = Math.floor( seconds / DAY_IN_SECONDS ) + 'd';
		} else if ( seconds >= HOUR_IN_SECONDS ) {
			diff = Math.floor( seconds / HOUR_IN_SECONDS ) + 'h';
		} else if ( seconds >= MINUTE_IN_SECONDS ) {
			diff = Math.floor( seconds / MINUTE_IN_SECONDS ) + 'm';
		}

		return diff;
	}

	function parseTweet( tweet ) {
		/* eslint-disable camelcase */

		let { text } = tweet;
		const {
			retweeted_status = false,
			entities: {
				urls = [],
				media = [],
				user_mentions = [],
				hashtags = [],
			},
		} = tweet;

		if ( retweeted_status ) {
			text = text.replace( /^RT @(\w+):/, `RT <a href="https://twitter.com/$1" title="Retweeted from ${ tweet.retweeted_status.user.name }" target="_blank" rel="nofollow">@$1</a>` );
		}

		// Convert URLs to links
		for ( const entity of urls ) {
			const { url, display_url } = entity;
			text = text.replace( url, `<a href="${ url }" target="_blank" rel="noopener nofollow">${ display_url }</a>` );
		}

		// Hide Media for now
		for ( const entity of media ) {
			const { url } = entity;
			text = text.replace( url, '' );
		}

		// Convert mentions to links
		for ( const entity of user_mentions ) {
			const { screen_name, name: display_name } = entity;
			text = text.replace( `@${ screen_name }`, `<a href="https://twitter.com/${ screen_name }" title="${ display_name }" target="_blank" rel="nofollow">@${ screen_name }</a>` );
		}

		// Convert hashtags to links
		for ( const entity of hashtags ) {
			const { text: tag } = entity;
			text = text.replace( `#${ tag }`, `<a href="https://twitter.com/search?q=${ encodeURIComponent( '#' + tag ) }" title="${ tag }" target="_blank" rel="nofollow">#${ tag }</a>` );
		}

		return text;

		/* eslint-enable camelcase */
	}

	$( '.canpath-twitter-feed' ).each( function() {
		const $feed = $( this );
		const $wrapper = $feed.find( '.--tweets' );

		const template = $feed.find( '.--tweet-template' ).html();

		get( '/wp-json/twitter-feeder/user-timeline', tweets => {
			tweets.forEach( tweet => {
				const tweetUrl = `https://twitter.com/${ tweet.user.screen_name }/status/${ tweet.id_str }`;
				const content = parseTweet( tweet );

				const $tweet = $( template );

				$tweet.find( '.--tweet-author-link' )
					.attr( 'href', tweet.user.url );

				$tweet.find( '.--tweet-author-name' )
					.text( tweet.user.name );

				$tweet.find( '.--tweet-author-handle' )
					.text( `@${ tweet.user.screen_name }` );

				$tweet.find( '.--tweet-link' )
					.attr( 'href', tweetUrl );

				$tweet.find( '.--tweet-date' )
					.attr( 'title', new Date( tweet.created_at ) )
					.text( ago( tweet.created_at ) );

				$tweet.find( '.--tweet-text' )
					.html( content );

				$wrapper.append( $tweet );
			} );
		}, 'json' );
	} );

	// =========================
	// ! Hexagon Map Handling
	// =========================

	$( '.canpath-hexamap' ).each( function() {
		const $map = $( this );

		$map.find( '[data-province]' ).not( 'g:not(.is-occupied)' ).on( 'app:focus mouseover focus', function() {
			const group = $( this ).data( 'province' );
			$map.find( '[data-province]' ).removeClass( 'is-active' )
				.filter( `[data-province="${ group }"]` ).addClass( 'is-active' );
		} );

		$map.find( 'a[data-province]' ).click( function( e ) {
			if ( IS_TOUCH ) {
				e.preventDefault();
			}
		} );

		$map.find( 'a[data-province]' ).first().trigger( 'app:focus' );

		let maxHeight = 0;
		$map.find( '.canpath-hexamap__infobox-wrapper' ).each( function() {
			const height = $( this ).show().height();
			if ( height > maxHeight ) {
				maxHeight = height;
			}
			$( this ).attr( 'style', '' );
		} );
		$map.find( '.canpath-hexamap__infoboxes' ).css( 'min-height', maxHeight + 'px' );

		$map.find( '.canpath-hexamap__infobox-wrapper__title' ).each( function() {
			const $parent = $( this ).parents( '.canpath-hexamap__infoboxes' ).first();
			const $header = $( this );
			const $target = $( this ).next();

			$header.click( function() {
				if ( ! $header.hasClass( 'is-active' ) ) {
					$header.addClass( 'is-active' );
					$target.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ) );
					$parent.find( '.canpath-hexamap__infobox-wrapper__title' ).not( $header ).each( function() {
						if ( $( this ).hasClass( 'is-active' ) ) {
							$( this ).removeClass( 'is-active' );
							$( this ).next().stop().show().animate( { height: 'toggle' }, () => $( this ).next().attr( 'style', '' ).removeClass( 'open' ) );
						}
					} );
				}
			} );
		} ).first().addClass( 'is-active' ).next().addClass( 'open' );
	} );

	// =========================
	// ! Search Bar
	// =========================

	$document.click( e => {
		if ( e.target.id !== 'search' && $( e.target ).parents( '#search' ).length === 0 &&
		$( e.target ).attr( 'href' ) !== '#search' && $( 'e.target' ).data( 'toggle' ) !== 'search' ) {
			$body.removeClass( 'show-search' );
		}
	} );

	// =========================
	// ! Super Nav
	// =========================

	const $supernav = $( '#header .menu-item-has-children' );

	$supernav.click( function() {
		$supernav.not( this ).removeClass( 'is-active' );
		$( this ).toggleClass( 'is-active' );

		if ( $( this ).hasClass( 'is-active' ) ) {
			lockScroll();
		} else {
			unlockScroll();
		}

		$body.toggleClass( 'showing-supernav', $( this ).hasClass( 'is-active' ) );
	} );

	$document.on( 'toggle:navigation', function() {
		$( '#navigation .is-active' ).removeClass( 'is-active' );
	} );

	// =========================
	// ! Peek-a-boo Nav Handling
	// =========================

	let lastScroll = 0;
	let lastDirection = 1;
	let lastPastHeader = false;

	$window.scroll( function() {
		const scroll = $window.scrollTop();
		const direction = scroll >= lastScroll ? 1 : -1;
		const pastHeader = scroll > 170;

		if ( direction !== lastDirection ) {
			$body.toggleClass( 'showing-sticky-nav', direction < 0 && pastHeader );
			$body.toggleClass( 'hiding-sticky-nav', direction > 0 && pastHeader );
		}

		if ( pastHeader !== lastPastHeader ) {
			$body.removeClass( 'showing-sticky-nav hiding-sticky-nav' );
		}

		lastScroll = scroll;
		lastDirection = direction;
		lastPastHeader = pastHeader;
	} );

	// Flag if browser seems to have a vertical scrollbar
	$html.toggleClass( 'has-scroll-bar', window.innerWidth > document.documentElement.offsetWidth );

	// =========================
	// ! Carousel Handling
	// =========================

	$( '[data-carousel]' ).each( function() {
		const $this = $( this ).addClass( 'carousel' );
		const selector = $this.data( 'carousel' );

		const $items = selector ? $this.find( selector ) : $this.children();

		if ( $items.length <= 1 ) {
			return;
		}

		const $nav = $( '<div class="carousel__nav"></div>' ).appendTo( this );

		// Set the height of the carousel to accomodate the tallest item
		let maxHeight = 0;
		$items.each( function() {
			const height = $( this ).height();
			if ( height > maxHeight ) {
				maxHeight = height;
			}

			// Also add a marker to the nav for it
			$nav.append( `<button class="carousel__nav__item">
				<svg><circle r="14" cx="15" cy="15"></circle></svg>
			</button>` );
		} ).wrap( '<div class="carousel__slide"></div>' );

		const $slides = $this.find( '.carousel__slide' );

		$this.css( 'min-height', maxHeight + 'px' );

		// get the nav items
		const $navItems = $nav.children();

		let current = 0;
		const total = $slides.length;
		const timer = 10; // 10 seconds

		function gotoSlide( index ) {
			if ( index >= total ) {
				index = 0;
			} else if ( index < 0 ) {
				index = total - 1;
			}

			$this.trigger( 'carousel:change', index );

			$slides.eq( current ).fadeOut( function() {
				$( this ).removeClass( 'is-current' ).attr( 'style', '' );
			} );

			current = index;

			$slides.eq( current ).fadeIn( function() {
				$( this ).addClass( 'is-current' ).attr( 'style', '' );
			} );

			// update the nav
			$navItems.removeClass( 'is-current' ).eq( current ).addClass( 'is-current' );
		}

		// init with the first slide/item flagged
		$slides.first().addClass( 'is-current' );
		$navItems.first().addClass( 'is-current' );

		// set timer animation duration
		$navItems.find( 'circle' ).css( 'animation-duration', timer + 's' );

		// auto advance
		const auto = setInterval( function() {
			gotoSlide( current + 1 );
		}, timer * 1000 );

		// click handling for manual navigation
		$navItems.click( function() {
			clearInterval( auto );
			gotoSlide( $( this ).index() );
		} );
	} );

	const BANNER_CAROUSEL_COLORS = [ 'orange', 'cyan', 'lime', 'blue', 'green' ];
	$( '.canpath-banner-group' ).on( 'carousel:change', function( e, index ) {
		const color = BANNER_CAROUSEL_COLORS[ index ] || BANNER_CAROUSEL_COLORS[ 0 ];

		$( this ).setFlagClass( 'is-color', color );
	} );

	// =========================
	// ! Snapshot Handling
	// =========================

	let $snapshotModal;
	const $snapshotOpener = $( '.canpath-snapshot__opener' );

	$( '.canpath-snapshot-graphic__button' ).click( function( e ) {
		e.preventDefault();

		const $target = $( $( this ).attr( 'href' ) );

		$snapshotOpener.text( $( this ).text() ).addClass( 'is-clickable' );

		if ( $snapshotModal && $snapshotModal.is( $target ) ) {
			$snapshotOpener.click();
		}

		$snapshotModal = $target;

		if ( $snapshotOpener.is( ':hidden' ) ) {
			$snapshotOpener.click();
		}

		$( this ).addClass( 'is-current' ).siblings().removeClass( 'is-current' );
	} );

	$snapshotOpener.click( function() {
		if ( $snapshotModal ) {
			$snapshotModal.addClass( 'is-active' ).siblings().removeClass( 'is-active' );
			lockScroll();
		}
	} );

	$( '.canpath-snapshot-modal__nav a' ).click( function( e ) {
		e.preventDefault();

		const $target = $( $( this ).attr( 'href' ) );

		$( this ).addClass( 'is-current' ).siblings().removeClass( 'is-current' );
		$target.addClass( 'is-active' ).siblings().removeClass( 'is-active' );
	} );

	$( '.canpath-snapshot-modal__nav a' ).click( function() {
		const $nav = $( this ).parents( '.canpath-snapshot-modal__nav' );
		$nav.removeClass( 'is-open' );
	} );

	$( '.canpath-snapshot-modal__nav-toggle' ).click( function() {
		const $modal = $( this ).parents( '.canpath-snapshot-modal' );

		$modal.find( '.canpath-snapshot-modal__nav' ).addClass( 'is-open' );
	} );

	$( '.canpath-snapshot-modal__close' ).click( function() {
		$( this ).parents( '.canpath-snapshot-modal' ).removeClass( 'is-active' )
			.find( '.canpath-snapshot-modal__nav' ).removeClass( 'is-open' );

		unlockScroll();
	} );

	// =========================
	// ! Decorative Bits
	// =========================

	if ( window.requestAnimationFrame && window.Intl && window.IntersectionObserver ) {
		const numberFormat = window.Intl && Intl.NumberFormat && new Intl.NumberFormat();

		function setupCountable( elm ) {
			const original = $( elm ).text();
			const total = parseInt( original.replace( /\D+/g, '' ) );
			const perFrame = Math.floor( total / 60 );

			let current = 0;

			let then = Date.now();

			function increment() {
				const now = Date.now();

				if ( now - then > 30 ) {
					current += perFrame;

					if ( current >= total ) {
						$( elm ).text( original );

						return;
					}

					$( elm ).text( numberFormat.format( current ) );

					then = now;
				}

				requestAnimationFrame( increment );
			}

			requestAnimationFrame( increment );
		}

		const countableObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				if ( change.isIntersecting ) {
					countableObserver.unobserve( change.target );
					setupCountable( change.target );
				}
			} );
		} );

		$( '.canpath-highlight.countable .canpath-highlight__title' ).each( function() {
			countableObserver.observe( this );
		} );
		$( '.canpath-stat .canpath-stat__value' ).each( function() {
			countableObserver.observe( this );
		} );
	}
} );
